const bundle = {
  close: () => 'Затвори',
  error: () => 'Грешка',
  warn: () => 'Упозорење',
  info: () => 'Информације',
  confirmation: () => 'Потврда',
  progressIndeterminate: () => 'У току',
  indexer_separatorLabel: (p: { FROM_SECTION: string; TO_SECTION: string }) =>
    'Између ' + p['FROM_SECTION'] + ' и ' + p['TO_SECTION'] + '.',
  indexer_disabledLabel: (p: { SECTION: string }) =>
    p['SECTION'] + '. Није пронађен ниједан подударан одјељак.',
  indexer_othersLabel: () => '#',
  indexer_keyboardInstructionText: () => 'Притисни Enter за избор вриједности.',
  indexer_touchInstructionText: () =>
    'Двапут додирнути  и држати. Чекати на звук и онда превући да би се преуредило.',
  inputPassword_show: () => 'Прикажи лозинку',
  inputPassword_hide: () => 'Сакриј лозинку',
  inputPassword_hidden: () => 'Лозинка је скривена',
  formControl_clear: () => 'Очисти',
  formControl_loading: () => 'Учитавање',
  formControl_maxLengthExceeded: (p: { MAX_LENGTH: string }) =>
    'Прекорачена је максимална дужина од ' + p['MAX_LENGTH'] + '.',
  formControl_maxLengthRemaining: (p: { CHARACTER_COUNT: string }) =>
    'Преостало знакова: ' + p['CHARACTER_COUNT'] + '.',
  select_noMatchesFound: () => 'Није пронађено ниједно подударање.',
  select_oneMatchFound: () => 'Пронађено је једно подударање',
  select_sizeMatchesFound: (p: { TOTAL_SIZE: string }) =>
    'Пронађено подударанја: ' + p['TOTAL_SIZE'],
  select_sizeOrMoreMatchesFound: (p: { TOTAL_SIZE: string }) =>
    'Пронађено подударанја: најманје ' + p['TOTAL_SIZE'],
  selectMultiple_showSelectedValues: () => 'Прикажи само изабране вриједности.',
  selectMultiple_valuesSelected: (p: { VALUE_COUNT: string }) =>
    'Изабрано вриједности: ' + p['VALUE_COUNT'] + '.',
  selectMultiple_countPlus: (p: { COUNT: string }) => p['COUNT'] + '+',
  selector_selected: () => 'Оквир је потврђен',
  selector_unselected: () => 'Оквир није потврђен',
  userAssistance_learnMore: () => 'Сазнај више',
  userAssistance_required: () => 'Обавезно',
  filePicker_singleFileUploadError: () => 'Учитај једну по једну датотеку',
  filePicker_singleTypeUploadError: (p: { fileType: string }) =>
    'Не можете учитати датотеке врсте ' + p['fileType'],
  filePicker_multipleFileTypeUploadError: (p: { fileTypes: string }) =>
    'Не можете учитати датотеке врсте ' + p['fileTypes'],
  filePicker_unknownFileTypeUploadError: () => 'непознато',
  filePicker_dropzonePrimaryText: () => 'Повуци и испусти',
  filePicker_dropzoneSecondaryText: () => 'Изабери датотеку или испусти неку овдје',
  filePicker_dropzoneSecondaryTextMultiple: () => 'Изабери или испусти датотеке овдје',
  filePicker_addFiles: () => 'Додај датотеке',
  plural_separator: () => ', ',
  inputNumber_increase: () => 'Повећај',
  inputNumber_decrease: () => 'Смањи',
  inputNumber_converterParseError: () => 'Enter a number.',
  noData_message: () => 'Нема ставки за приказ',
  message_navigationFromMessagesRegion: () =>
    'Подручје за уношење порука. Притисните F6 за повратаk на претходно фокусирани елемент.',
  message_navigationToMessagesRegion: () =>
    'Подручје за поруке садржи нове поруке. Притисните F6 за прелазак на подручје с најновијим порукама.',
  messageToast_allMessagesClosed: () => 'Све тоаст поруке су затворене.'
};
export default bundle;
